import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

// Credenciais e Chaves da conta (OpenAI, Supabase e chaves livres).
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/other-settings'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'other_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
